// import {
//   Box,
//   Text,
//   Button,
//   useDisclosure,
//   Divider,
//   Avatar,
//   Flex,
//   Stat,
//   StatLabel,
//   StatNumber,
//   StatHelpText,
//   StatArrow,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   TableContainer,
//   useMediaQuery,
//   Spinner
// } from "@chakra-ui/react";
// import { useEffect, useState, useReducer } from "react";
// import { useParams } from "react-router-dom";
// import { Footer } from "../../../components/Footer";
// import { OrdersSlider } from "../../../components/OrdersSlider";
// import { api } from "../../../services/api";
// import { theme } from "../../../styles/theme";
// import { useAuth } from "../../../Hooks/useAuth";
// import Navbar from "../../../components/Navbar";
// import { Form } from '../Form';
// import swal  from 'sweetalert';
// import { FaPen, FaAngleUp, FaAngleDown, FaCreditCard, FaTrashAlt, FaCcVisa, FaCcMastercard  } from "react-icons/fa";


// export function Profile() {
//   const { user } = useAuth();
//   const [profile, setProfile] = useReducer(
//     (state, newState) => ({ ...state, ...newState }),
//     {
//       full_name: "",
//       address_street: "",
//       address_number: "",
//       address_complement: "",
//       address_neighborhood: "",
//       address_postal_code: "",
//       city_id: "",
//       state_id: "",
//       phone_number: "",
//       email: "",
//       password: ""
//     }
//   );
//   const { id } = useParams()
//   const [orders, setOrders] = useState([])
//   const [pendingOrders, setPendingOrders] = useState([])
//   const [paidOrders, setPaidOrders] = useState([])

//   const [states, setStates] = useState([])
//   const [cities, setCities] = useState([])
//   const [userCredits, setUserCredits] = useState([])
//   const { isOpen, onOpen, onClose } = useDisclosure()
//   const [mapedCitiesForState, setMapedCitiesForState] = useState([]);
//   const [userPhoto, setUserPhoto] = useState(null);
//   const [creditHistorySection, setCreditHistorySection] = useState(false);
//   const [userDocument, setUserDocument] = useState("");
//   const [intervalId, setIntervalId] = useState(null);
//   const [userPhoneNumber, setUserPhoneNumber] = useState("");
//   const [savedCards, setSavedCards] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [loadingPage, setLoadingPage] = useState(false);
//   const currentDate = new Date();
//   const isMobile = useMediaQuery("(max-width: 767px)")[0];
//   const gridTemplateColumns = isMobile
//   ? "repeat(1, 1fr)"
//   : "repeat(3, 1fr)";

//   const handleLocality = (e) => {
//     setMapedCitiesForState(cities.filter(element => element.state_id === Number(e.target.value)))
//   }


//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfile({ [name]: value });

//     if (name === "photo") {
//       const file = e.target.files[0];
//       setProfile((prevState) => ({ ...prevState, photo: file }));
//     } else {
//       setProfile((prevState) => ({ ...prevState, [name]: value }));
//     }
//   }

//   // async function fetchUser() {
//   //   setLoadingPage(true)
//   //   const response = await api.get(`/api/v1/users/${id}`)
//   //   setProfile(response.data.user)
//   //   setUserDocument(response.data.user.document_number)
//   //   setUserPhoneNumber(response.data.user.phone_number)

//   //   setStates(response.data.states)
//   //   setCities(response.data.cities)
//   //   setUserCredits(response.data.credits)
//   //   setOrders(response.data.order_total_info)
//   //   setPendingOrders(response.data.order_total_info.filter(e => e.payment.status === "pending").sort((a, b) => new Date(b.payment.created_at) - new Date(a.payment.created_at)))
//   //   setPaidOrders(response.data.order_total_info.filter(e => e.payment.status === "paid").sort((a, b) => new Date(b.payment.created_at) - new Date(a.payment.created_at)))
//   //   setLoadingPage(false)
//   // }

//   async function fetchUser() {
//     try {
//       setLoadingPage(true);
//       const response = await api.get(`/api/v1/users/${id}`);
//       const data = response.data;
//       const orders = data.order_total_info || [];

//       setProfile(data.user || {});
//       setUserDocument(data.user?.document_number || "");
//       setUserPhoneNumber(data.user?.phone_number || "");
//       setStates(data.states || []);
//       setCities(data.cities || []);
//       setUserCredits(data.credits || []);
//       const sixtyDaysAgo = new Date();
//       sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 60);

//       const recentOrders = orders.filter(order => {
//         const createdAt = order?.payment?.created_at;
//         return createdAt && new Date(createdAt) >= sixtyDaysAgo;
//       });
//       setOrders(orders);
//       setPendingOrders(
//         orders
//           .filter(e => e?.payment?.status === "pending")
//           .sort((a, b) => new Date(b?.payment?.created_at || 0) - new Date(a?.payment?.created_at || 0))
//       );
//       setPaidOrders(
//         orders
//           .filter(e => e?.payment?.status === "paid")
//           .sort((a, b) => new Date(b?.payment?.created_at || 0) - new Date(a?.payment?.created_at || 0))
//       );

//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     } finally {
//       setLoadingPage(false);
//     }
//   }

//   const handlePayment = (e, paymentId) => {
//     window.location = `/pagamentos/${paymentId}`
//   }


//   // useEffect(() => {
//   //   // Fetch saved cards
//   //   api.get('/api/v1/payments/saved_cards').then((response) => {
//   //     setSavedCards(response.data.saved_cards);
//   //   }).catch(() => {
//   //     setSavedCards([]);
//   //   });
//   // }, []);

//   useEffect(() => {
//     fetchUser();
//     const urlParams = new URLSearchParams(window.location.search);
//     const missingData = urlParams.get("missing_data");
//     if (missingData === "true") {
//       swal({
//         title: "Quase lá!",
//         text: "Preencha seu Nome, Documento e Celular para efetuar a compra",
//         icon: "info",
//       });
//     }
//   }, [])

//   useEffect(() => {
//     fetchUser();
//     const urlParams = new URLSearchParams(window.location.search);
//     const paymentSuccess = urlParams.get("payment_success");

//     if (paymentSuccess === "true") {
//       swal({
//         title: "Ótimo",
//         text: "Seu pagamento foi confirmado, você ja pode ver os detalhes do seu pedido no histórico.",
//         icon: "success",
//       });
//     }

//   }, [])



//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setUserPhoto(file);
//   };

//   const toggleCreditsHistory = (e) => {
//     e.preventDefault()
//     setCreditHistorySection(!creditHistorySection)
//   }

//   const handleDocumentDisplay = (number) => {
//     let cleanedString = number;
//     if (cleanedString.length === 11) {
//       var formattedNumber = cleanedString.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
//     } else if (cleanedString.length === 14) {
//       var formattedNumber = cleanedString.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
//     } else if (cleanedString.length === 8) {
//       var formattedNumber = cleanedString.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
//     } else {
//       var formattedNumber = "";
//     }
//     return formattedNumber
//   }

//   function formatPhoneNumber(phoneNumber) {
//     const cleaned = phoneNumber.replace(/\D/g, '');
//     if (cleaned.length === 11) {
//       return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
//     } else {
//       return phoneNumber;
//     }
//   }

//   const handleEditUser = async (e) => {
//     e.preventDefault();
//     let cleanedDocumentNumber = userDocument ? userDocument.replace(/[.\-\s]/g, '') : '';
//     let cleanedPhoneNumber = userPhoneNumber ? userPhoneNumber.replace(/\D/g, '') : '';
//     const formData = new FormData();
//     formData.append("user[email]", profile.email);
//     formData.append("user[document_number]", cleanedDocumentNumber);
//     formData.append("user[full_name]", profile.full_name);
//     if (profile.password !== "") {
//       formData.append("user[password]", profile.password);
//     }
//     formData.append("user[phone_number]", cleanedPhoneNumber);
//     formData.append("user[address_street]", profile.address_street);
//     formData.append("user[address_number]", profile.address_number);
//     formData.append("user[address_complement]", profile.address_complement);
//     formData.append("user[address_neighborhood]", profile.address_neighborhood);
//     formData.append("user[address_postal_code]", profile.address_postal_code);
//     if (profile.city_id !== null) {
//       formData.append("user[city_id]", profile.city_id);
//     }
//     if (profile.state_id !== null) {
//       formData.append("user[state_id]", profile.state_id);
//     }
//     if (userPhoto) {
//       formData.append("user[photo]", userPhoto);
//     }

//     try {
//       const response = await api.put(`/api/v1/users/${id}`, formData, {
//         headers: {
//           'Content-Type': "multipart/form-data",
//         },
//       });

//       if (response.data.message === "Usuário atualizado com sucesso") {
//         swal({
//           title: "Ohhh Yeahhh",
//           text: "Dados atualizados com sucesso!",
//           icon: "success",
//         });
//         localStorage.setItem("userPhoto", response.data.user_photo);
//         onClose();
//         window.location.href = `/perfil/${user.id}`;
//       } else {
//         swal({
//           title: "Ohhh Noo",
//           text: "Algo deu errado!",
//           icon: "error",
//         });
//       }
//     } catch (error) {
//       if (error.response && error.response.data && error.response.data.errors) {
//         setErrors(error.response.data.errors); // Set errors from the API response
//       } else {
//         swal({
//           title: "Ohhh Noo",
//           text: "Erro inesperado. Por favor, tente novamente.",
//           icon: "error",
//         });
//       }
//     }
//   };

//   const handleRemovePaymentMethod = async (cardId) => {
//     try {
//       const response = await api.delete(`/api/v1/payments/remove_saved_card`, {
//         data: { card_id: cardId },
//       });

//       if (response.data.message === "Card removed successfully") {
//         swal({
//           title: "Card Removed",
//           text: "Your card was removed successfully.",
//           icon: "success",
//         });
//       } else {
//         swal({
//           title: "Error",
//           text: "Failed to remove card.",
//           icon: "error",
//         });
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       swal({
//         title: "Error",
//         text: "An unexpected error occurred.",
//         icon: "error",
//       });
//     }
//   };

//   function formatDateDifference(createdDate) {
//     const createdDateObject = new Date(createdDate);
//     const currentDateObject = new Date();
//     const monthNames = [
//       "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
//       "Jul", "Ago", "Set", "Out", "Nov", "Dez"
//     ];
//     const monthCreated = monthNames[createdDateObject.getUTCMonth()];
//     const yearCreated = createdDateObject.getUTCFullYear().toString().substring(2);
//     const monthCurrent = monthNames[currentDateObject.getUTCMonth()];
//     const yearCurrent = currentDateObject.getUTCFullYear().toString().substring(2);
//     const formattedCreatedDate = `${monthCreated} ${yearCreated}`;
//     const formattedCurrentDate = `${monthCurrent} ${yearCurrent}`;
//     return (
//       <Text>{formattedCreatedDate} - {formattedCurrentDate}</Text>
//     )
//   }


//   async function removePayment(e, payment) {
//     e.preventDefault()
//     if (window.confirm("Tem certeza de que deseja remover pedido?")) {
//       try {
//         const response = await api.delete(`/api/v1/payments/${payment}`);
//         if (response.data.success) {
//           swal({
//             title: "Ok",
//             text: "Pedido removido",
//             icon: "success",
//           });
//           fetchUser()
//         } else {
//           swal({
//             title: "Opss",
//             text: "Algo deu errado!!",
//             icon: "error",
//           });
//         }
//       } catch (error) {
//         console.error('Error removing payment:', error);
//         return false;
//       }
//     }
//   }

//   const getCardIcon = (brand) => {
//     switch (brand) {
//       case 'Visa':
//         return <FaCcVisa size="1.3rem"/>;
//       case 'Master Card':
//         return <FaCcMastercard size="1.3rem"/>;
//       default:
//         return <FaCreditCard size="1.3rem"/>;
//     }
//   };



//   return (<>
//     <Navbar/>
//     <Box
//       background="transparent"
//       margin={{base: "0px", md: ""}}
//       height='auto'
//        padding={{base: '5% 0%', md: '1% 0% 2% 0%'}}
//       marginTop={{ base: "6rem", md: "10rem" }}
//       mx={{base: "1rem", md: "3rem"}}

//     >
//       <Form
//         isOpen={isOpen}
//         onClose={onClose}
//         theme={theme}
//         profile={profile}
//         user={user}
//         handleProfileChange={handleProfileChange}
//         handleEditUser={handleEditUser}
//         states={states}
//         cities={cities}
//         handleLocality={handleLocality}
//         mapedCitiesForState={mapedCitiesForState}
//         handleFileChange={handleFileChange}
//         userPhoto={userPhoto}
//         setUserDocument={setUserDocument}
//         userDocument={userDocument}
//         setUserPhoneNumber={setUserPhoneNumber}
//         userPhoneNumber={userPhoneNumber}
//         errors={errors}
//       />
//       <Box
//         display={{base: 'block', md: 'flex'}}
//         justifyContent={"space-between"}
//         width={{base: '100%', md: '100%'}}
//         px="2%"
//         gap={{base: '10', md: ''}}
//         margin={{base: 'auto', md: '0 auto'}}
//       >
//         <Box
//           width={{base: '90%', md: '60%'}}
//           margin={{base: 'auto', md: '0% 0 4% 0'}}
//         >
//           <Box
//             border={`1px solid rgba(0, 74, 51, 0.08)`}
//             boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
//             borderRadius="16px"
//             my="20px"
//             bg="white"
//             overflow="hidden"
//             transition="all 0.3s ease"
//             _hover={{
//               boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
//               borderColor: "rgba(0, 74, 51, 0.16)"
//             }}
//           >
//             <Box
//               bg={`linear-gradient(135deg, ${theme.colors.primaryGreen} 0%, rgba(0, 74, 51, 0.95) 100%)`}
//               p="16px 20px"
//             >
//               <Text
//                 fontWeight="900"
//                 fontSize="18px"
//                 color={theme.colors.primaryOrange}
//               >
//                 Histórico de Pedidos
//               </Text>
//             </Box>
//           </Box>
//           <Box p="20px">
//             <Divider/>
//             {paidOrders.length > 0 && (<>
//               <Text mt="20px" fontWeight="500" color={theme.colors.primaryGreen}>Pedir novamente:</Text>
//               <OrdersSlider orders={paidOrders.slice(0, 5)} cities={cities} states={states} type={"orderAgain"}/>
//             </>)}

//             {pendingOrders.length > 0 && (<>
//               <Divider/>
//               <Text mt="20px" mb="10px" fontWeight="500" color={theme.colors.primaryGreen}>Pendentes:</Text>
//               <OrdersSlider orders={pendingOrders.slice(0, 20)} cities={cities} states={states} type={"pending"}/>
//             </>)}
//             {paidOrders.length > 0 && (<>
//               <Divider/>
//               <Text mt="20px" fontWeight="500" color={theme.colors.primaryGreen}>Concluídos:</Text>
//               <OrdersSlider orders={paidOrders.slice(0, 20)} cities={cities} states={states} type={"paid"} />
//             </>)}
//             {orders.length <= 0 && !loadingPage && (
//               <Text
//                 textAlign={"center"}
//                 fontSize={"25px"}
//                 fontWeight={"bolder"}
//               >
//                 Nenhum pedido.
//               </Text>
//             )}
//             {(orders.length <= 0 && loadingPage) && (
//               <Box display='flex' justifyContent='center' padding='50px'>
//                 <Spinner color={theme.colors.primary} margin='auto'/>
//               </Box>
//             )}
//           </Box>
//         </Box>
//         <Box
//           width={{base: '90%', md: '40%'}}
//           margin={{base: '30px auto 0px auto', md: '0% 0 4% 0'}}
//         >
//           <Box
//             border={`1px solid rgba(0, 74, 51, 0.08)`}
//             boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
//             borderRadius="16px"
//             my="15px"
//             bg="white"
//             overflow="hidden"
//             transition="all 0.3s ease"
//             _hover={{
//               boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
//               borderColor: "rgba(0, 74, 51, 0.16)"
//             }}
//           >
//             <Box
//               bg={`linear-gradient(135deg, ${theme.colors.primaryOrange} 0%, rgba(252, 143, 4, 0.95) 100%)`}
//               p="16px 20px"
//             >
//               <Text
//                 fontWeight="900"
//                 fontSize="18px"
//                 color={theme.colors.primaryGreen}
//               >
//                 Carteira de Créditos
//               </Text>
//             </Box>
//             <Box p="20px">


//               <Box display='flex' justifyContent='space-between' pt="5%">
//                 <Stat>
//                   <StatLabel>Créditos disponíveis</StatLabel>
//                   <StatNumber>{userCredits.length > 0 && <span>{(userCredits.reduce((n, { amount }) => n + amount, 0)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</span> || <span>R$0,00</span>}</StatNumber>
//                   <StatHelpText>{formatDateDifference(profile.created_at)}</StatHelpText>
//                 </Stat>
//                 <Button
//                   onClick={(e) => toggleCreditsHistory(e)}
//                   background="transparent"
//                   color={theme.colors.primaryGreen}
//                   borderColor={theme.colors.primary}
//                   padding='0px'
//                   alignItems='start'
//                   display='flex'
//                   gap={2}
//                   _hover={{
//                     color: `${theme.colors.primaryGreen}`,
//                     bg: "transparent",
//                   }}
//                 >
//                   Extrato de Créditos
//                   {!creditHistorySection ?
//                     <span><FaAngleDown></FaAngleDown></span>
//                   :
//                     <span><FaAngleUp></FaAngleUp></span>
//                   }
//                 </Button>
//               </Box>
//               {creditHistorySection && (<>
//                 <TableContainer>
//                   <Table variant='simple' color='black'>
//                     <Thead>
//                       <Tr width='100%'>
//                         <Th textAlign='center' borderColor={theme.colors.primaryGreen}>Pedido</Th>
//                         <Th textAlign='center' borderColor={theme.colors.primaryGreen}>Data</Th>
//                         <Th textAlign='center' borderColor={theme.colors.primaryGreen}>Valor</Th>
//                       </Tr>
//                     </Thead>
//                     <Tbody>
//                       {userCredits.length > 0 && (
//                         <>
//                           {userCredits.map((credit) => (
//                             <Tr width='100%' key={credit.id}>
//                               <Td display="flex" justifyContent='center'  borderColor={theme.colors.primaryGreen}>
//                                 <Stat flex='0 1 1%'>
//                                   <StatHelpText>
//                                     {credit.amount > 0 ?  <StatArrow type='increase' /> : <StatArrow type='decrease' />}
//                                   </StatHelpText>
//                                 </Stat>
//                                 #{credit.payment_id}
//                               </Td>
//                               <Td textAlign='center' marginBottom='-1px' borderColor={theme.colors.primaryGreen}>
//                                 {new Date(credit.created_at).toLocaleDateString('pt-BR')}
//                               </Td>
//                               <Td textAlign='center' borderColor={theme.colors.primaryGreen}>
//                                 {credit.amount.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})}
//                               </Td>
//                             </Tr>
//                           ))}
//                         </>
//                       )}
//                     </Tbody>
//                   </Table>
//                 </TableContainer>
//                 <Box display='flex' justifyContent='space-between' margin='10px 40px 0px 40px'>
//                   <Text fontWeight='bolder' color={theme.colors.primaryOrange}>Total</Text>
//                   <Text fontWeight='bolder' color={theme.colors.primaryOrange}>{(userCredits.reduce((n, { amount }) => n + amount, 0)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Text>
//                 </Box>
//               </>)}
//               {savedCards.length > 0 && (
//                 <>
//                   <Divider orientation='horizontal' my="15px" display={{base: "block", md: "block"}} borderColor={theme.colors.primary}/>
//                   <Text fontWeight="bold">
//                     Meus Cartões
//                   </Text>
//                   <Box>
//                   {savedCards.map((card) => (
//                     <Box key={card.id} display="flex" justifyContent="space-between" alignItems="center">
//                       <Box display="flex" gap="5px">
//                         {getCardIcon(card.data.brand)}
//                         <Text fontSize="14px">{card.data.display_number}</Text>
//                         <Text fontSize="14px">{card.data.holder_name}</Text>
//                         <Text fontSize="14px">{card.data.month}/{card.data.year}</Text>
//                       </Box>
//                       <Button
//                         background="transparent"
//                         border="none"
//                         color="red"
//                         onClick={() => handleRemovePaymentMethod(card.id)}
//                         _hover={{
//                           color: "primaryOrange"
//                         }}
//                       >
//                         <FaTrashAlt />
//                       </Button>
//                     </Box>
//                   ))}
//                   </Box>
//                 </>
//               )}
//             </Box>
//           </Box>
//           <Box
//             border={`1px solid rgba(0, 74, 51, 0.08)`}
//             boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
//             borderRadius="16px"
//             my="15px"
//             bg="white"
//             overflow="hidden"
//             transition="all 0.3s ease"
//             _hover={{
//               boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
//               borderColor: "rgba(0, 74, 51, 0.16)"
//             }}
//           >
//             <Box
//               bg={`linear-gradient(135deg, ${theme.colors.primaryGreen} 0%, rgba(0, 74, 51, 0.95) 100%)`}
//               p="16px 20px"
//             >
//               <Text
//                 fontWeight="900"
//                 fontSize="18px"
//                 color={theme.colors.primaryOrange}
//               >
//                 Dados Pessoais
//               </Text>
//             </Box>
//             <Box p="20px">
//               <Box position='relative' display='inline-block'>
//                 <Avatar
//                   size={{ base: 'md', md: 'md' }}
//                   display='block'
//                   max-width='100%'
//                   border={`2px solid ${theme.colors.primaryOrange}`}

//                   src={localStorage.getItem('userPhoto') !== "" ? localStorage.getItem('userPhoto') : 'https://img.freepik.com/free-icon/user_318-159711.jpg'}
//                 />
//                 <Button position='absolute' width='20px' bottom='0px' right='-5px' padding='0px' borderRadius='50%' size='xs'
//                   onClick={onOpen}
//                   background="rgba(245,245,245, .6)"
//                   color={theme.colors.primaryOrange}
//                   border={`1px solid ${theme.colors.primaryOrange}`}
//                   _hover={{
//                     color: `${theme.colors.primaryOrange}`,
//                     borderColor: `${theme.colors.primaryGreen}`,
//                     backgroundColor: `${theme.colors.primaryGreen}`

//                   }}
//                 >
//                   <FaPen></FaPen>
//                 </Button>
//               </Box>
//             </Box>
//             <Divider pt="10px"/>
//             <Box
//               height={{ base: 'auto', md: "auto" }}
//               borderRadius="0 0 15px 15px"
//               marginBottom={{ base: '0px', md: '0px' }}
//               width='100%'
//             >
//               <Flex alignItems='center' justifyContent="center" flexDirection={{ base: 'column', md: 'column' }}>
//                 <Box width='100%' padding='20px 10px'>
//                   <Flex alignItems='center' gap={1} justifyContent='space-between'>
//                     <Text fontSize='18px' fontWeight='500'>Nome:</Text>
//                     <Text>{profile.full_name ? <span>{profile.full_name}</span> : <span></span>}</Text>
//                   </Flex>
//                   <Flex alignItems='center' gap={1} justifyContent='space-between'>
//                     <Text fontSize='18px' fontWeight='500'>Celular:</Text>
//                     <Text>{profile.phone_number ? <span>{formatPhoneNumber(profile.phone_number)}</span> : <span></span>}</Text>
//                   </Flex>
//                   <Flex alignItems='center' gap={1} justifyContent='space-between'>
//                     <Text fontSize='18px' fontWeight='500'>Documento:</Text>
//                     <Text>{profile.document_number ? <span>{handleDocumentDisplay(profile.document_number)}</span> : <span></span>}</Text>
//                   </Flex>
//                   <Flex alignItems='center' gap={1} justifyContent='space-between'>
//                     <Text fontSize='18px' fontWeight='500'>Email:</Text>
//                     <Text>{profile.email ? <span>{profile.email}</span> : <span></span>}</Text>
//                   </Flex>
//                   {(profile.address_street || profile.address_number || profile.address_complement  || profile.address_neighborhood || profile.city_id || profile.state_id || profile.address_postal_code) && (<>
//                     <Text fontSize='18px' fontWeight='500'>Endereço:</Text>
//                     <Text>{profile.address_street ? <span>{profile.address_street}</span> : <span></span>}, {profile.address_number ? <span>{profile.address_number}</span> : <span></span>}{profile.address_complement ? <span>, {profile.address_complement}</span> : <span></span>}, {profile.address_neighborhood ? <span>{profile.address_neighborhood}</span> : <span></span>}</Text>
//                     <Text>{profile.city_id ? <span>{cities.find(city => city.id === profile.city_id)?.name}</span> : <span></span>} - {profile.state_id ? <span>{states.find(state => state.id === profile.state_id)?.acronym}</span> : <span></span>}{profile.address_postal_code ? <span> | {profile.address_postal_code}</span> : <span></span>}</Text>
//                   </>)}
//                 </Box>
//               </Flex>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//     <Footer />
//   </>)
// }


import {
  Box,
  Text,
  Button,
  useDisclosure,
  Divider,
  Avatar,
  Flex,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useMediaQuery,
  Skeleton,
  useToast
} from "@chakra-ui/react";
import { BoozenToast } from '../../../components/BoozenToast';
import { BoozenConfirmDialog, useBoozenConfirm } from '../../../components/BoozenConfirm';
import { useEffect, useState, useReducer, useContext } from "react";
import { useParams } from "react-router-dom";
import { Footer } from "../../../components/Footer";
import { CartContext } from '../../../Context/CartContext';
import { AddToCartPopUp } from '../../../components/AddToCartPopUp';
import { api } from "../../../services/api";
import { theme } from "../../../styles/theme";
import { useAuth } from "../../../Hooks/useAuth";
import Navbar from "../../../components/Navbar";
import { Form } from '../Form';
import { FaPen, FaAngleUp, FaAngleDown, FaCreditCard, FaTrashAlt, FaCcVisa, FaCcMastercard } from "react-icons/fa";

// ─── Design tokens ────────────────────────────────────────────────────────────
const GREEN = theme.colors.primaryGreen; // #004a33
const ORANGE = theme.colors.primaryOrange; // #fc8f04
const CREAM = "#ffffff";
const BORDER = "rgba(45,74,30,0.10)";

// ─── Tiny helpers ─────────────────────────────────────────────────────────────
const Card = ({ children, style = {} }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: 24,
      border: "1px solid rgba(0,74,51,.08)",
      boxShadow: "0 10px 30px rgba(0,0,0,.05)",
      overflow: "hidden",
      ...style
    }}
  >
    {children}
  </div>
);
const CardHeader = ({ title, accent = GREEN, textColor = "#fff", badge }) => (
  <div style={{
    background: `linear-gradient(135deg, ${accent} 0%, ${accent}dd 100%)`,
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  }}>
    <span style={{ fontWeight: 800, fontSize: 15, color: textColor, letterSpacing: "-0.02em" }}>
      {title}
    </span>
    {badge != null && (
      <span style={{
        background: "rgba(255,255,255,0.18)",
        borderRadius: 99,
        padding: "2px 10px",
        fontSize: 12,
        fontWeight: 700,
        color: textColor,
        flexShrink: 0,
      }}>
        {badge}
      </span>
    )}
  </div>
);

const InfoRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "10px 0", borderBottom: `1px solid ${BORDER}` }}>
      <span style={{ fontSize: 13, color: "#999", fontWeight: 500, flexShrink: 0, marginRight: 12 }}>{label}</span>
      <span style={{ fontSize: 14, color: "#1a1a1a", fontWeight: 500, textAlign: "right", wordBreak: "break-word" }}>{value}</span>
    </div>
  );
};

// ─── Stat pill ────────────────────────────────────────────────────────────────
const CreditPill = ({ label, value, accent }) => (
  <div style={{ background: `${accent}10`, borderRadius: 14, padding: "12px 16px", flex: 1 }}>
    <div style={{ fontSize: 11, color: accent, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4 }}>{label}</div>
    <div style={{ fontSize: 20, fontWeight: 800, color: accent, letterSpacing: "-0.03em" }}>{value}</div>
  </div>
);

export function Profile() {
  const { user } = useAuth();
  const [profile, setProfile] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      full_name: "", address_street: "", address_number: "",
      address_complement: "", address_neighborhood: "",
      address_postal_code: "", city_id: "", state_id: "",
      phone_number: "", email: "", password: ""
    }
  );
  const { id } = useParams();
  const [orders, setOrders]               = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [paidOrders, setPaidOrders]       = useState([]);
  const [states, setStates]               = useState([]);
  const [cities, setCities]               = useState([]);
  const [userCredits, setUserCredits]     = useState([]);
  const { isOpen, onOpen, onClose }       = useDisclosure();
  const [mapedCitiesForState, setMapedCitiesForState] = useState([]);
  const [userPhoto, setUserPhoto]         = useState(null);
  const [creditHistorySection, setCreditHistorySection] = useState(false);
  const [userDocument, setUserDocument]   = useState("");
  const [intervalId, setIntervalId]       = useState(null);
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [savedCards, setSavedCards]       = useState([]);
  const [errors, setErrors]               = useState({});
  const [loadingPage, setLoadingPage]     = useState(false);
  const currentDate = new Date();
  const isMobile = useMediaQuery("(max-width: 767px)")[0];
  const toast = useToast();
  const { confirm, confirmDialogProps } = useBoozenConfirm();
  const { handleSetSelectedProduct, showCartPopUp } = useContext(CartContext);

  const showToast = (type, title, description) => {
    toast({
      position: 'top',
      duration: 6000,
      isClosable: true,
      render: ({ onClose }) => (
        <BoozenToast type={type} title={title} description={description} onClose={onClose} />
      ),
    });
  };

  const handleLocality = (e) => {
    setMapedCitiesForState(cities.filter(element => element.state_id === Number(e.target.value)));
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile({ [name]: value });
    if (name === "photo") {
      const file = e.target.files[0];
      setProfile((prevState) => ({ ...prevState, photo: file }));
    } else {
      setProfile((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  async function fetchUser() {
    try {
      setLoadingPage(true);
      const response = await api.get(`/api/v1/users/${id}`);
      const data = response.data;
      const orders = data.order_total_info || [];
      setProfile(data.user || {});
      setUserDocument(data.user?.document_number || "");
      setUserPhoneNumber(data.user?.phone_number || "");
      setStates(data.states || []);
      setCities(data.cities || []);
      setUserCredits(data.credits || []);
      setOrders(orders);
      setPendingOrders(orders.filter(e => e?.payment?.status === "pending").sort((a, b) => new Date(b?.payment?.created_at || 0) - new Date(a?.payment?.created_at || 0)));
      setPaidOrders(orders.filter(e => e?.payment?.status === "paid").sort((a, b) => new Date(b?.payment?.created_at || 0) - new Date(a?.payment?.created_at || 0)));
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoadingPage(false);
    }
  }

  const handlePayment = (e, paymentId) => { window.location = `/pagamentos/${paymentId}`; };

  function getUnitsPerCase(bo) {
    const u = Number(bo?.product?.quantity_per_box);
    return Number.isFinite(u) && u > 0 ? u : 1;
  }

  function resolveUnitPriceFromUnityTiers(pricingTable, qtyCases) {
    if (!Array.isArray(pricingTable) || pricingTable.length === 0) return null;
    const q = Number(qtyCases) || 0;
    const sorted = [...pricingTable].sort((a, b) => Number(b.unity) - Number(a.unity));
    const tier = sorted.find(t => q >= Number(t.unity));
    return tier ? Number(tier.price_per_unity) : null; // preço por UNIDADE
  }

  function getItemCurrentTotal(bo) {
    const qtyCases = Number(bo?.item?.quantity) || 0; // quantidade em CAIXAS
    const unitsPerCase = getUnitsPerCase(bo); // unidades por caixa
    if (bo.current_total != null) return Number(bo.current_total); // se o back já mandou pronto

    const unit = resolveUnitPriceFromUnityTiers(bo.pricing_table, qtyCases); // preço por unidade
    if (unit == null) return null;
    return unit * qtyCases * unitsPerCase; // total (unit × caixas × unidades/caixa)
  }

  function getCurrentOrderTotal(order) {
    let total = 0;
    let anyResolved = false;
    for (const bo of order.batch_orders || []) {
      const t = getItemCurrentTotal(bo);
      if (t != null) {
        total += t;
        anyResolved = true;
      }
    }
    return anyResolved ? total : null;
  }

  // Busca o preço vigente do produto no momento do clique (não confia no preço
  // carregado junto com o pedido antigo, que pode ter ficado obsoleto na tela aberta).
  async function fetchLiveTotalForItem(bo) {
    const qtyCases = Number(bo?.item?.quantity) || 0;
    const unitsPerCase = getUnitsPerCase(bo);
    try {
      const { data } = await api.get(`/api/v1/products/${bo.product.id}`);
      const unit = resolveUnitPriceFromUnityTiers(data?.prices, qtyCases);
      if (unit == null || !data?.batch) return null;
      return { amount: unit * qtyCases * unitsPerCase, batch: data.batch };
    } catch (error) {
      console.error("Error fetching current product price:", error);
      return null;
    }
  }

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps
    fetchUser();
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get("missing_data") === "true") {
      setTimeout(() => showToast(
        "warning",
        "Quase lá!",
        "Preencha seu Nome, Documento e Celular para efetuar a compra."
      ), 400);
    }

    // From payment page (user stayed and watched confirmation)
    if (urlParams.get("payment_success") === "true") {
      window.history.replaceState({}, '', window.location.pathname);
      setTimeout(() => showToast(
        "success",
        "Pagamento confirmado!",
        "Seu pagamento foi processado com sucesso. Confira seu pedido no histórico abaixo."
      ), 400);
    }

    // From PendingPaymentChecker (user had navigated away from payment page)
    if (localStorage.getItem('showPaymentSuccess') === '1') {
      localStorage.removeItem('showPaymentSuccess');
      setTimeout(() => showToast(
        "success",
        "Pagamento confirmado!",
        "Seu pagamento PIX foi processado com sucesso. Confira seu pedido no histórico abaixo."
      ), 400);
    }
  }, []);

  // Preços podem mudar em outra aba (admin) enquanto o perfil fica aberto;
  // atualiza os pedidos ao voltar pra aba pra não exibir um total desatualizado.
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "visible") fetchUser();
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFileChange = (e) => { const file = e.target.files[0]; setUserPhoto(file); };
  const toggleCreditsHistory = (e) => { e.preventDefault(); setCreditHistorySection(!creditHistorySection); };

  const handleDocumentDisplay = (number) => {
    let n = number;
    if (n.length === 11) return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    if (n.length === 14) return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    if (n.length === 8)  return n.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
    return "";
  };

  function formatPhoneNumber(phoneNumber) {
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length === 11) return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    return phoneNumber;
  }

  const handleEditUser = async (e) => {
    e.preventDefault();
    let cleanedDocumentNumber = userDocument ? userDocument.replace(/[.\-\s]/g, '') : '';
    let cleanedPhoneNumber = userPhoneNumber ? userPhoneNumber.replace(/\D/g, '') : '';
    const formData = new FormData();
    formData.append("user[email]", profile.email);
    formData.append("user[document_number]", cleanedDocumentNumber);
    formData.append("user[full_name]", profile.full_name);
    if (profile.password !== "") formData.append("user[password]", profile.password);
    formData.append("user[phone_number]", cleanedPhoneNumber);
    formData.append("user[address_street]", profile.address_street);
    formData.append("user[address_number]", profile.address_number);
    formData.append("user[address_complement]", profile.address_complement);
    formData.append("user[address_neighborhood]", profile.address_neighborhood);
    formData.append("user[address_postal_code]", profile.address_postal_code);
    if (profile.city_id !== null) formData.append("user[city_id]", profile.city_id);
    if (profile.state_id !== null) formData.append("user[state_id]", profile.state_id);
    if (userPhoto) formData.append("user[photo]", userPhoto);
    try {
      const response = await api.put(`/api/v1/users/${id}`, formData, { headers: { 'Content-Type': "multipart/form-data" } });
      if (response.data.message === "Usuário atualizado com sucesso") {
        showToast("success", "Dados atualizados!", "Seus dados foram salvos com sucesso.");
        localStorage.setItem("userPhoto", response.data.user_photo);
        onClose();
        window.location.href = `/perfil/${user.id}`;
      } else {
        showToast("error", "Algo deu errado", "Não foi possível salvar os dados. Tente novamente.");
      }
    } catch (error) {
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      } else {
        showToast("error", "Erro inesperado", "Por favor, tente novamente.");
      }
    }
  };

  const handleRemovePaymentMethod = async (cardId) => {
    try {
      const response = await api.delete(`/api/v1/payments/remove_saved_card`, { data: { card_id: cardId } });
      if (response.data.message === "Card removed successfully") {
        showToast("success", "Cartão removido", "Seu cartão foi removido com sucesso.");
      } else {
        showToast("error", "Erro", "Não foi possível remover o cartão.");
      }
    } catch (error) {
      showToast("error", "Erro inesperado", "Ocorreu um erro ao remover o cartão.");
    }
  };

  function formatDateDifference(createdDate) {
    const d = new Date(createdDate);
    const now = new Date();
    const months = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
    return `${months[d.getUTCMonth()]} ${d.getUTCFullYear().toString().slice(2)} – ${months[now.getUTCMonth()]} ${now.getUTCFullYear().toString().slice(2)}`;
  }

  async function removePayment(e, payment) {
    e.preventDefault();
    const ok = await confirm({
      title: "Remover pedido",
      description: "Tem certeza que deseja remover este pedido? Esta ação não pode ser desfeita.",
      confirmLabel: "Remover",
      cancelLabel: "Cancelar",
      danger: true,
      icon: "⚠️",
    });
    if (!ok) return;
    try {
      const response = await api.delete(`/api/v1/payments/${payment}`);
      if (response.data.success) {
        showToast("success", "Pedido removido", "O pedido foi removido com sucesso.");
        fetchUser();
      } else {
        showToast("error", "Oops!", "Algo deu errado. Tente novamente.");
      }
    } catch (error) { console.error('Error removing payment:', error); }
  }

  const getCardIcon = (brand) => {
    switch (brand) {
      case 'Visa': return <FaCcVisa size="1.3rem"/>;
      case 'Master Card': return <FaCcMastercard size="1.3rem"/>;
      default: return <FaCreditCard size="1.3rem"/>;
    }
  };

  const totalCredits = userCredits.reduce((n, { amount }) => n + amount, 0);
  const photoSrc = localStorage.getItem('userPhoto') || 'https://img.freepik.com/free-icon/user_318-159711.jpg';

  return (
    <>
      <BoozenConfirmDialog {...confirmDialogProps} />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800;900&display=swap');
        .bz-profile * { font-family: 'DM Sans', sans-serif; box-sizing: border-box; }
        .bz-profile { background: #f8f8f8; }
        .edit-btn:hover { background: ${ORANGE} !important; color: #fff !important; transform: scale(1.05); }
        .credit-toggle:hover { opacity: 0.8; }
        .card-remove:hover { color: #e53e3e !important; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp 0.35s cubic-bezier(0.23,1,0.32,1) both; }
        .fade-up:nth-child(2) { animation-delay: 0.05s; }
        .fade-up:nth-child(3) { animation-delay: 0.10s; }
        .fade-up:nth-child(4) { animation-delay: 0.15s; }
      `}</style>

      <Navbar />

      <div className="bz-profile" style={{ minHeight: "100vh", paddingTop: 0, background: "#f8f8f8" }}>

        {/* ── Hero header ─────────────────────────────────────────────────── */}
        <Box
          bg={`
            radial-gradient(
              circle at top right,
              rgba(252,143,4,.12) 0%,
              transparent 30%
            ),
            linear-gradient(
              135deg,
              #004a33 0%,
              #00553b 50%,
              #006646 100%
            )
          `}
          pt={{ base: "120px", md: "160px" }}
          pb="64px"
          px="20px"
          position="relative"
          overflow="hidden"
        >
          {/* decorative circles */}
          <div style={{ position: "absolute", top: -40, right: -40, width: 200, height: 200, borderRadius: "50%", background: `${ORANGE}18`, pointerEvents: "none" }} />
          <div style={{ position: "absolute", bottom: -60, left: -30, width: 160, height: 160, borderRadius: "50%", background: `${ORANGE}10`, pointerEvents: "none" }} />

          <div style={{ maxWidth: 1000, margin: "0 auto" }}>
            {/* Top row: avatar + name + edit button */}
            <div style={{ display: "flex", alignItems: "flex-end", gap: 20, flexWrap: "wrap" }}>
              {/* Avatar */}
              <div style={{ position: "relative", flexShrink: 0 }}>
                <div style={{ width: 110, height: 110, borderRadius: "50%", border: `3px solid ${ORANGE}`, overflow: "hidden", background: "#fff" }}>
                  <img src={photoSrc} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </div>
                <button
                  className="edit-btn"
                  onClick={onOpen}
                  style={{
                    position: "absolute", bottom: 0, right: -4,
                    width: 26, height: 26, borderRadius: "50%",
                    background: "#fff", border: `2px solid ${ORANGE}`,
                    color: ORANGE, cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    transition: "all 0.15s", fontSize: 11,
                  }}
                >
                  <FaPen />
                </button>
              </div>

              {/* Name + email */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: isMobile ? 24 : 34, fontWeight: 900, color: "#fff", letterSpacing: "-0.03em", lineHeight: 1.1, marginBottom: 4 }}>
                  {profile.full_name || "Meu Perfil"}
                </div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", fontWeight: 500 }}>{profile.email}</div>
              </div>

              {/* Edit button desktop */}
              <button
                className="edit-btn"
                onClick={onOpen}
                style={{
                  display: isMobile ? "none" : "flex",
                  alignItems: "center", gap: 6,
                  background: "transparent",
                  border: `1.5px solid ${ORANGE}`,
                  color: ORANGE,
                  borderRadius: 99, padding: "8px 18px",
                  fontSize: 13, fontWeight: 700, cursor: "pointer",
                  transition: "all 0.15s",
                }}
              >
                <FaPen size={11} /> Editar perfil
              </button>
            </div>

            {/* Stats row — appears after data loads */}
            {!loadingPage && (
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 20 }}>
                <div style={{ background: "rgba(255,255,255,0.10)", borderRadius: 12, padding: "8px 16px", border: "1px solid rgba(255,255,255,0.15)" }}>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.55)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>Pedidos</div>
                  <div style={{ fontSize: 22, fontWeight: 900, color: "#fff", lineHeight: 1.2 }}>{orders.length}</div>
                </div>
                <div style={{ background: "rgba(255,255,255,0.10)", borderRadius: 12, padding: "8px 16px", border: "1px solid rgba(255,255,255,0.15)" }}>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.55)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>Concluídos</div>
                  <div style={{ fontSize: 22, fontWeight: 900, color: "#fff", lineHeight: 1.2 }}>{paidOrders.length}</div>
                </div>
                {pendingOrders.length > 0 && (
                  <div style={{ background: `${ORANGE}20`, borderRadius: 12, padding: "8px 16px", border: `1px solid ${ORANGE}40` }}>
                    <div style={{ fontSize: 10, color: ORANGE, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>Pendentes</div>
                    <div style={{ fontSize: 22, fontWeight: 900, color: ORANGE, lineHeight: 1.2 }}>{pendingOrders.length}</div>
                  </div>
                )}
                {totalCredits > 0 && (
                  <div style={{ background: `${ORANGE}15`, borderRadius: 12, padding: "8px 16px", border: `1px solid ${ORANGE}35` }}>
                    <div style={{ fontSize: 10, color: ORANGE, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>Créditos</div>
                    <div style={{ fontSize: 22, fontWeight: 900, color: ORANGE, lineHeight: 1.2 }}>
                      {totalCredits.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </Box>

        {/* ── Main content ─────────────────────────────────────────────────── */}
        <div   style={{
            maxWidth: 1280,
            margin: "0 auto",
            padding: isMobile
              ? "0 16px 40px"
              : "0 24px 60px",
            marginTop: -40
          }}
        >

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                isMobile
                  ? "1fr"
                  : "340px minmax(0,1fr)",
              gap: 24,
              alignItems: "start"
            }}
          >



            {/* ── SIDEBAR: Credits + Personal data ─────────────────────────── */}
            <div
              style={{
                width: "100%",
                position: isMobile ? "static" : "sticky",
                top: 120,
                alignSelf: "start",
                order: isMobile ? 2 : 1,
              }}
            >

              {/* Credits card */}
              <Box className="fade-up" marginBottom={{base: "12px", md: "0px"}}>
                <Card >
                  <CardHeader title="💰  Carteira Boozen" accent={ORANGE} textColor={GREEN} />
                  <div style={{ padding: 16 }}>

                    {/* Balance pill */}
                    <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
                      <Box
                      bg={`linear-gradient(
                        135deg,
                        ${GREEN} 0%,
                        #00553b 100%
                      )`}
                      borderRadius="20px"
                      p="20px"
                    >
                      <Text
                        color="rgba(255,255,255,.7)"
                        fontSize="12px"
                        fontWeight="700"
                        textTransform="uppercase"
                      >
                        Saldo Disponível
                      </Text>

                      <Text
                        color="white"
                        fontSize="32px"
                        fontWeight="900"
                        mt="4px"
                      >
                        {totalCredits.toLocaleString(
                          "pt-BR",
                          {
                            style: "currency",
                            currency: "BRL"
                          }
                        )}
                      </Text>
                    </Box>
                    </div>
                    <div style={{ fontSize: 11, color: "#bbb", marginBottom: 12 }}>{profile.created_at ? formatDateDifference(profile.created_at) : ""}</div>

                    {/* Toggle extrato */}
                    <button
                      className="credit-toggle"
                      onClick={toggleCreditsHistory}
                      style={{
                        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
                        background: `${GREEN}08`, border: `1px solid ${BORDER}`,
                        borderRadius: 10, padding: "9px 14px",
                        fontSize: 13, fontWeight: 600, color: GREEN, cursor: "pointer",
                        transition: "opacity 0.15s",
                      }}
                    >
                      Extrato de Créditos
                      {creditHistorySection ? <FaAngleUp /> : <FaAngleDown />}
                    </button>

                    {creditHistorySection && userCredits.length > 0 && (
                      <div
                        style={{
                          marginTop: 12,
                          maxHeight: 260,
                          overflowY: "auto"
                        }}
                      >
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                          <thead>
                            <tr style={{ background: `${GREEN}08` }}>
                              <th style={{ padding: "8px 10px", textAlign: "left", color: "#888", fontWeight: 600 }}>Pedido</th>
                              <th style={{ padding: "8px 10px", textAlign: "center", color: "#888", fontWeight: 600 }}>Data</th>
                              <th style={{ padding: "8px 10px", textAlign: "right", color: "#888", fontWeight: 600 }}>Valor</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userCredits.map((credit) => (
                              <tr key={credit.id} style={{ borderTop: `1px solid ${BORDER}` }}>
                                <td style={{ padding: "8px 10px", color: "#333" }}>
                                  <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                    {credit.amount > 0
                                      ? <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5 1L9 9H1L5 1Z" fill="#38A169"/></svg>
                                      : <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5 9L1 1H9L5 9Z" fill="#E53E3E"/></svg>
                                    }
                                    #{credit.payment_id}
                                  </span>
                                </td>
                                <td style={{ padding: "8px 10px", textAlign: "center", color: "#777" }}>
                                  {new Date(credit.created_at).toLocaleDateString('pt-BR')}
                                </td>
                                <td style={{ padding: "8px 10px", textAlign: "right", fontWeight: 700, color: credit.amount > 0 ? GREEN : ORANGE }}>
                                  {credit.amount.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr style={{ background: `${ORANGE}08`, borderTop: `1px solid ${BORDER}` }}>
                              <td colSpan={2} style={{ padding: "8px 10px", fontWeight: 800, color: ORANGE, fontSize: 12 }}>Total</td>
                              <td style={{ padding: "8px 10px", textAlign: "right", fontWeight: 800, color: ORANGE, fontSize: 12 }}>
                                {totalCredits.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    )}

                    {/* Saved cards */}
                    {savedCards.length > 0 && (
                      <>
                        <div style={{ height: 1, background: BORDER, margin: "16px 0" }} />
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#555", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>Meus Cartões</div>
                        {savedCards.map((card) => (
                          <div key={card.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: `1px solid ${BORDER}` }}>
                            <div style={{ display: "flex", gap: 8, alignItems: "center", color: "#444", fontSize: 13 }}>
                              {getCardIcon(card.data.brand)}
                              <span>{card.data.display_number}</span>
                              <span style={{ color: "#aaa" }}>{card.data.month}/{card.data.year}</span>
                            </div>
                            <button
                              className="card-remove"
                              onClick={() => handleRemovePaymentMethod(card.id)}
                              style={{ background: "none", border: "none", color: "#ccc", cursor: "pointer", transition: "color 0.15s" }}
                            >
                              <FaTrashAlt size={13} />
                            </button>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </Card>
              </Box>

              {/* Personal data card */}
              <div className="fade-up">
                <Card>
                  <CardHeader title="👤  Dados Pessoais" accent={GREEN} textColor={ORANGE} />
                  <div style={{ padding: "16px 20px" }}>
                    <InfoRow label="Nome"       value={profile.full_name} />
                    <InfoRow label="Celular"    value={profile.phone_number ? formatPhoneNumber(profile.phone_number) : null} />
                    <InfoRow label="Documento"  value={profile.document_number ? handleDocumentDisplay(profile.document_number) : null} />
                    <InfoRow label="Email"      value={profile.email} />
                    {(profile.address_street || profile.address_neighborhood) && (
                      <div style={{ padding: "10px 0" }}>
                        <div style={{ fontSize: 13, color: "#999", fontWeight: 500, marginBottom: 4 }}>Endereço</div>
                        <div style={{ fontSize: 14, color: "#1a1a1a", fontWeight: 500 }}>
                          {[profile.address_street, profile.address_number, profile.address_complement].filter(Boolean).join(", ")}
                        </div>
                        <div style={{ fontSize: 13, color: "#777", marginTop: 2 }}>
                          {[
                            profile.address_neighborhood,
                            cities.find(c => c.id === profile.city_id)?.name,
                            states.find(s => s.id === profile.state_id)?.acronym,
                            profile.address_postal_code
                          ].filter(Boolean).join(" · ")}
                        </div>
                      </div>
                    )}

                    {/* Mobile edit button */}
                    <button
                      className="edit-btn"
                      onClick={onOpen}
                      style={{
                        marginTop: 14, width: "100%",
                        display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                        background: GREEN, color: ORANGE,
                        border: "none", borderRadius: 12,
                        padding: "11px 0", fontSize: 14, fontWeight: 700,
                        cursor: "pointer", transition: "all 0.15s",
                      }}
                    >
                      <FaPen size={12} /> Editar dados
                    </button>
                  </div>
                </Card>
              </div>

            </div>

            {/* ── ORDERS ───────────────────────────────────────────── */}
            <div className="fade-up" style={{ flex: "1 1 0", minWidth: 0, width: isMobile ? "100%" : undefined, order: isMobile ? 1 : 2 }}>
              <Card style={{ height: isMobile ? "auto" : "calc(100vh - 220px)", display: "flex", flexDirection: "column" }}>
                <CardHeader title="📦  Meus Pedidos" accent={GREEN} textColor={ORANGE} badge={orders.length > 0 ? orders.length : undefined} />
                <div style={{ padding: "16px", overflowY: "auto", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", gap: 10 }}>

                  {loadingPage && orders.length === 0 ? (
                    [0, 1, 2, 3].map(i => <Skeleton key={i} height="120px" borderRadius="16px" />)
                  ) : orders.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#aaa" }}>
                      <div style={{ fontSize: 40, marginBottom: 10 }}>🛍️</div>
                      <div style={{ fontWeight: 700, fontSize: 15, color: "#555" }}>Nenhum pedido ainda</div>
                      <div style={{ fontSize: 13, marginTop: 4 }}>Seus pedidos aparecerão aqui</div>
                    </div>
                  ) : (
                    [...pendingOrders, ...paidOrders].map((order) => {
                      const isPending = order.payment.status === "pending";
                      const rawDate = isPending
                        ? (order.payment.created_at || order.payment.updated_at)
                        : (order.payment.updated_at || order.payment.created_at);
                      const date = rawDate ? new Date(rawDate) : null;
                      const displayDate = date && !isNaN(date)
                        ? date.toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" })
                        : null;
                      const total = Number(order.payment.price_in_cents) / 100;
                      const currentTotal = !isPending ? getCurrentOrderTotal(order) : null;
                      const priceChanged = currentTotal != null && Math.abs(currentTotal - total) > 0.01;
                      const payMethod = order.payment.payment_method === "pix" ? "💠 PIX" : "💳 Cartão";
                      const deliveryMethod = order.batch_orders[0]?.item?.delivery_method;

                      const addBizDays = (d, n) => {
                        let count = 0;
                        const r = new Date(d);
                        while (count < n) {
                          r.setDate(r.getDate() + 1);
                          if (r.getDay() !== 0 && r.getDay() !== 6) count++;
                        }
                        return r;
                      };
                      const fmtShort = (d) => d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
                      const paidAt = !isPending && date && !isNaN(date) ? date : null;
                      const previsionText = paidAt
                        ? deliveryMethod === "collect"
                          ? `a partir de ${fmtShort(addBizDays(paidAt, 8))}`
                          : `${fmtShort(addBizDays(paidAt, 2))} – ${fmtShort(addBizDays(paidAt, 8))}`
                        : null;

                      return (
                        <Box
                          key={order.payment.id}
                          bg="white"
                          border={`1px solid ${isPending ? `${ORANGE}35` : "rgba(0,74,51,.09)"}`}
                          borderLeft={`4px solid ${isPending ? ORANGE : GREEN}`}
                          borderRadius="16px"
                          p="16px"
                          transition="all 0.15s"
                          _hover={{ boxShadow: "0 4px 20px rgba(0,74,51,.1)", transform: "translateY(-1px)" }}
                        >
                          {/* Row 1: order number + badges */}
                          <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb="10px">
                            <Box>
                              <Text fontWeight="900" fontSize="14px" color={GREEN} lineHeight="1.2">
                                Pedido #{order.payment.id}
                              </Text>
                              <Text fontSize="11px" color="gray.400" mt="2px">
                                {displayDate ?? "—"}
                              </Text>
                            </Box>
                            <Box display="flex" gap="6px" flexWrap="wrap" justifyContent="flex-end">
                              <Box bg="rgba(0,74,51,.06)" borderRadius="99px" px="8px" py="3px">
                                <Text fontSize="10px" fontWeight="700" color={GREEN}>{payMethod}</Text>
                              </Box>
                              {deliveryMethod && (
                                <Box
                                  bg={deliveryMethod === "collect" ? "rgba(0,74,51,.06)" : "rgba(41,128,185,.08)"}
                                  borderRadius="99px" px="8px" py="3px"
                                >
                                  <Text fontSize="10px" fontWeight="700" color={deliveryMethod === "collect" ? GREEN : "#2980b9"}>
                                    {deliveryMethod === "collect" ? "🏪 Retirada" : "🚚 Entrega"}
                                  </Text>
                                </Box>
                              )}
                              <Box
                                bg={isPending ? `${ORANGE}18` : "rgba(0,74,51,.08)"}
                                borderRadius="99px" px="8px" py="3px"
                              >
                                <Text fontSize="10px" fontWeight="800" color={isPending ? ORANGE : GREEN}>
                                  {isPending ? "⏳ Pendente" : "✅ Pago"}
                                </Text>
                              </Box>
                            </Box>
                          </Box>

                          {/* Row 2: items */}
                          <Box
                            bg="rgba(0,74,51,.025)"
                            borderRadius="10px"
                            p="10px"
                            mb="10px"
                          >
                            {order.batch_orders.slice(0, 3).map((bo, i) => (
                              <Box key={i} display="flex" justifyContent="space-between" alignItems="center" py="3px">
                                <Text fontSize="12px" color="gray.600" noOfLines={1} flex={1} mr={2}>
                                  {bo.product?.name}
                                </Text>
                                <Text fontSize="11px" fontWeight="700" color={GREEN} flexShrink={0}>
                                  × {bo.item?.quantity} {bo.batch?.unity_of_measurement}
                                </Text>
                              </Box>
                            ))}
                            {order.batch_orders.length > 3 && (
                              <Text fontSize="11px" color="gray.400" mt="4px">
                                +{order.batch_orders.length - 3} produto(s)
                              </Text>
                            )}
                          </Box>

                          {/* Row 2b: delivery prevision */}
                          {previsionText ? (
                            <Box
                              display="flex" alignItems="center" gap="8px"
                              bg={deliveryMethod === "collect" ? "rgba(0,74,51,.04)" : "rgba(41,128,185,.05)"}
                              border={`1px solid ${deliveryMethod === "collect" ? "rgba(0,74,51,.12)" : "rgba(41,128,185,.14)"}`}
                              borderRadius="10px" p="9px 12px" mb="10px"
                            >
                              <Text fontSize="14px" flexShrink={0}>
                                {deliveryMethod === "collect" ? "🏪" : "🚚"}
                              </Text>
                              <Box>
                                <Text fontSize="10px" fontWeight="800" textTransform="uppercase" letterSpacing="0.05em"
                                  color={deliveryMethod === "collect" ? GREEN : "#2980b9"}>
                                  {deliveryMethod === "collect" ? "Disponível para retirada" : "Previsão de entrega"}
                                </Text>
                                <Text fontSize="12px" fontWeight="700" color={deliveryMethod === "collect" ? "#1a4731" : "#1a5276"}>
                                  {previsionText}
                                </Text>
                              </Box>
                            </Box>
                          ) : isPending ? (
                            <Box
                              display="flex" alignItems="center" gap="8px"
                              bg={`${ORANGE}08`} border={`1px solid ${ORANGE}25`}
                              borderRadius="10px" p="9px 12px" mb="10px"
                            >
                              <Text fontSize="14px" flexShrink={0}>📅</Text>
                              <Text fontSize="11px" fontWeight="700" color={ORANGE}>
                                {deliveryMethod === "collect"
                                  ? "Disponível ~8 dias úteis após confirmação"
                                  : "Previsão: 2 a 8 dias úteis após confirmação"}
                              </Text>
                            </Box>
                          ) : null}

                          {/* Row 3 (paid only): delivery status */}
                          {!isPending && (() => {
                            const firstItem = order.batch_orders[0]?.item;
                            const deliveryStatus = firstItem?.delivery_status;
                            const statusMap = {
                              pending:          { label: "Aguardando disponibilidade", color: "#e67e22", bg: "rgba(230,126,34,.08)", icon: "⏳" },
                              out_for_delivery: { label: "Saiu para entrega",          color: "#2980b9", bg: "rgba(41,128,185,.08)",   icon: "🚚" },
                              delivered:        { label: "Entregue",                   color: "#27ae60", bg: "rgba(39,174,96,.08)",    icon: "✅" },
                              collected:        { label: "Retirado na loja",           color: "#27ae60", bg: "rgba(39,174,96,.08)",    icon: "✅" },
                              cancelled:        { label: "Cancelado",                  color: "#e74c3c", bg: "rgba(231,76,60,.08)",    icon: "❌" },
                            };
                            const ds = deliveryStatus ? statusMap[deliveryStatus] : null;
                            const fmtAddr = (a) => {
                              if (!a) return null;
                              if (typeof a === "string") return a;
                              return [a.address_street, a.address_number, a.address_neighborhood]
                                .filter(Boolean).join(", ") || null;
                            };
                            const address = deliveryMethod === "delivery"
                              ? fmtAddr(firstItem?.delivery_address)
                              : fmtAddr(order.batch_orders[0]?.collection_address);

                            return (
                              <Box
                                mb="12px"
                                p="10px"
                                borderRadius="10px"
                                bg={ds?.bg ?? "rgba(0,74,51,.03)"}
                                border={`1px solid ${ds?.color ?? GREEN}22`}
                              >
                                <Box display="flex" alignItems="center" gap="6px">
                                  <Text fontSize="13px">{ds?.icon ?? "📦"}</Text>
                                  <Text fontSize="11px" fontWeight="800" color={ds?.color ?? GREEN}>
                                    {ds?.label ?? "Verificando status..."}
                                  </Text>
                                </Box>
                                {address && (
                                  <Text fontSize="10px" color="gray.500" mt="4px" noOfLines={1}>
                                    {address}
                                  </Text>
                                )}
                              </Box>
                            );
                          })()}

                          {/* Row 4: total + CTA */}
                          <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                              <Text fontSize="10px" color="gray.400" fontWeight="600" textTransform="uppercase" letterSpacing="0.05em">Total pago</Text>
                              <Text fontWeight="900" fontSize="18px" color={GREEN} lineHeight="1.2">
                                {total.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                              </Text>
                              {priceChanged && (
                                <Box display="flex" alignItems="center" gap="4px" mt="2px">
                                  <Text fontSize="11px" fontWeight="800" color={currentTotal > total ? ORANGE : GREEN}>
                                    {currentTotal > total ? "▲" : "▼"} Pedir de novo: {currentTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                  </Text>
                                </Box>
                              )}
                            </Box>
                            {isPending ? (
                              <Box
                                as="button"
                                bg={GREEN}
                                color={ORANGE}
                                borderRadius="12px"
                                px="16px"
                                py="9px"
                                fontSize="13px"
                                fontWeight="800"
                                cursor="pointer"
                                border="none"
                                onClick={() => { window.location = `/pagamentos/${order.payment.id}`; }}
                                style={{ transition: "opacity 0.15s" }}
                                _hover={{ opacity: 0.88 }}
                              >
                                Continuar pagamento →
                              </Box>
                            ) : (
                              <Box
                                as="button"
                                bg="transparent"
                                color={GREEN}
                                border={`1.5px solid rgba(0,74,51,.25)`}
                                borderRadius="12px"
                                px="16px"
                                py="8px"
                                fontSize="13px"
                                fontWeight="700"
                                cursor="pointer"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  for (const bo of order.batch_orders) {
                                    if (!(bo.product && bo.batch && bo.item)) continue;

                                    const live = await fetchLiveTotalForItem(bo);
                                    const fallbackAmount = getItemCurrentTotal(bo);
                                    const updatedAmount = live?.amount ?? fallbackAmount ?? Number(bo.item.amount);
                                    const updatedBatch = live?.batch ?? bo.batch;

                                    handleSetSelectedProduct(e, bo.product, updatedBatch, updatedAmount, bo.item.quantity);
                                  }
                                }}
                                style={{ transition: "all 0.15s" }}
                                _hover={{ background: "rgba(0,74,51,.05)", borderColor: GREEN }}
                              >
                                🔄 Pedir novamente
                              </Box>
                            )}
                          </Box>
                        </Box>
                      );
                    })
                  )}
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {showCartPopUp && <AddToCartPopUp />}

      <Form
        isOpen={isOpen}
        onClose={onClose}
        theme={theme}
        profile={profile}
        user={user}
        handleProfileChange={handleProfileChange}
        handleEditUser={handleEditUser}
        states={states}
        cities={cities}
        handleLocality={handleLocality}
        mapedCitiesForState={mapedCitiesForState}
        handleFileChange={handleFileChange}
        userPhoto={userPhoto}
        setUserDocument={setUserDocument}
        userDocument={userDocument}
        setUserPhoneNumber={setUserPhoneNumber}
        userPhoneNumber={userPhoneNumber}
        errors={errors}
      />
    </>
  );
}
